import { useContext } from 'react'

import NavMenuContext from '../../contexts/NavMenuContext'

export default function useIsNavMenuOpen() {
  return Boolean(useContext(NavMenuContext)?.isOpen)
}
